<template>
  <div class="cloud-tags">
    <span
      v-for="(tag, i) in tags"
      :key="tag"
      class="tag"
      :style="{ fontSize: getFont(i) + 'px' }"
      @click="addTagToQuery(tag)"
    >
      {{ tag }}
    </span>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'CloudTags',
  components: {}
})
class CloudTags extends Vue {
  tagFontSizeMinimum = 14;
  tagFontSizeMaximum = 40;

  addTagToQuery(tag) {
      this.addTagsAndGo([tag])
  }

  get tags() {
    return this.queryTags.slice(0, this.user.maxtagincloud)
  }

  get counts() {
    return this.queryTagsCount
  }

  get tmax() {
    return this.queryTagsCount[0] || 1
  }

  get tmin() {
    return this.queryTagsCount[this.queryTagsCount.length - 1] || 0
  }

  getFont(index) {
    let count = this.counts[index]
    let result = (this.tagFontSizeMaximum * (count - this.tmin)) / (this.tmax - this.tmin)
    if (result < this.tagFontSizeMinimum) {
      result = this.tagFontSizeMinimum
    }

    return result
  }
}

export default CloudTags
</script>

<style lang="less" scoped>
.cloud-tags {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: center;
  width: 100%;
  min-height: 160px;

  margin-bottom: var(--margin--small);
  padding: var(--margin--large);

  color: white;
  text-align: center;

  background: var(--color-analog);
  border-bottom: 1px solid var(--color-separation-border);
}

.tag {
  margin: var(--margin--tiny);

  cursor: pointer;

  transition: all 0.2s ease;
  animation: reveal-zoom 1s ease;

  &:hover {
    color: var(--color-hover);
    transform: translateY(-2px);
  }
}
</style>
